import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import RoundedButton from 'components/RoundedButton';

const ErrorContent = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const goToZoosk = async () => {
    window.location.href = 'https://www.zoosk.com/inbox';
  };

  let content;

  switch (searchParams.has('type') && searchParams.get('type')) {
    // case 'experience-not-found':
    //   content = 'Experience not found';
    //   break;
    // case 'unauthorized':
    //   content = 'Unauthorized access';
    //   break;
    default:
      content = 'This product is no longer available';
      break;
  }

  return (
    <Box padding={'1rem'} display={'flex'} flexDirection={'column'} flex={'1 0 auto'}>
      <Typography variant={'h4'} gutterBottom>{content}</Typography>
      <Typography paragraph>You can head back to the Zoosk app by clicking on the button below.</Typography>
      <RoundedButton
        component={RouterLink}
        sx={{
          width: '100%',
          margin: 'auto 0 0 0',
          textDecoration: 'none',
          backgroundColor: 'var(--zoosk-light-blue)',
          '&:hover': {
            backgroundColor: 'var(--zoosk-light-blue-light)',
          }
        }}
        onClick={goToZoosk}
      >
        Back to Zoosk
      </RoundedButton>
    </Box>
  )
};

export default ErrorContent;
